module.exports = __webpack_public_path__ + "static/media/pix3.47b80e4b.jpg";